import React from 'react';
import { Button, ButtonProps } from './Button';

export default function (props: ButtonProps) {
  return <Button className="ghost" {...props} />;
}
